import { Capacitor } from '@capacitor/core';
import { scan as defaultScan } from '~/utils/CapacitorBarcodeScanner.default';
import { iosScan } from '~/utils/CapacitorBarcodeScanner.ios';

export async function startScan() {
  if (Capacitor.getPlatform() == 'ios') {
    return iosScan();
  }

  return defaultScan();
}
